import { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "https://go.brandhives.com";

export default function UnsubscribePage() {
  const G = "#0077B5";
  const [token, setToken] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = window.location.hash;
    const qIdx = hash.indexOf("?");
    if (qIdx >= 0) {
      const t = new URLSearchParams(hash.slice(qIdx)).get("token");
      setToken(t);
    }
  }, []);

  const handleConfirm = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/app/api/user/unsubscribe?token=${encodeURIComponent(token)}`);
      if (res.ok) {
        setConfirmed(true);
      } else {
        const d = await res.json().catch(() => ({}));
        setError(d.error || "Something went wrong. Please try again.");
      }
    } catch {
      setError("Could not reach the server. Please try again.");
    }
    setLoading(false);
  };

  if (confirmed) {
    return (
      <div style={{ background: "#F3F2EF", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
        <div style={{ maxWidth: 480, width: "100%", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 24, fontWeight: 700, color: G, marginBottom: 40 }}>BrandHives</div>
          <div style={{ fontSize: 48, marginBottom: 20 }}>✓</div>
          <div style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 26, marginBottom: 16 }}>You've been unsubscribed.</div>
          <p style={{ fontSize: 14, color: "#666", lineHeight: 1.7 }}>All emails and automated posts have been stopped. Your account has been cancelled.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: "#F3F2EF", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
      <div style={{ maxWidth: 480, width: "100%", padding: "48px 24px", textAlign: "center" }}>
        <div style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 24, fontWeight: 700, color: G, marginBottom: 40 }}>BrandHives</div>
        <div style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 26, marginBottom: 16 }}>Are you sure you want to unsubscribe?</div>
        <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 10, padding: "20px 24px", marginBottom: 32, textAlign: "left" }}>
          <div style={{ fontSize: 14, color: "#7F1D1D", fontWeight: 600, marginBottom: 8 }}>Unsubscribing will:</div>
          <ul style={{ fontSize: 14, color: "#7F1D1D", lineHeight: 1.8, margin: 0, paddingLeft: 20 }}>
            <li>Stop all emails from BrandHives</li>
            <li>Cancel your subscription immediately</li>
            <li>Stop all automated LinkedIn posts</li>
          </ul>
        </div>
        {error && <div style={{ color: "#EF4444", fontSize: 13, marginBottom: 16 }}>{error}</div>}
        <button
          onClick={handleConfirm}
          disabled={loading || !token}
          style={{ width: "100%", background: "#EF4444", color: "#fff", border: "none", borderRadius: 10, padding: "16px", fontSize: 15, cursor: loading ? "not-allowed" : "pointer", marginBottom: 12, opacity: loading ? 0.7 : 1 }}
        >
          {loading ? "Processing…" : "Yes, unsubscribe and cancel everything"}
        </button>
        <button
          onClick={() => { window.location.hash = "#/dashboard"; }}
          style={{ width: "100%", background: "transparent", color: "#374151", border: "1px solid #D1D5DB", borderRadius: 10, padding: "14px", fontSize: 14, cursor: "pointer" }}
        >
          No, keep my account active
        </button>
      </div>
    </div>
  );
}
